import { createSelector } from "@reduxjs/toolkit";

const getWebbuilderState = (state: any) => state.webbuilder || {};

export const selectSectionsById: any = createSelector(
  [getWebbuilderState],
  (wb: any) => wb.sectionsById || {},
);

export const selectSectionOrder: any = createSelector(
  [getWebbuilderState],
  (wb: any) => wb.sectionOrder || [],
);

export const selectSectionsArray: any = createSelector(
  [selectSectionsById, selectSectionOrder],
  (byId: any, order: any) => {
    const sections = order.map((id: string) => byId[id]).filter(Boolean);
    console.log("🟡 Selector selectSectionsArray recomputed:", {
      orderLength: order.length,
      byIdCount: Object.keys(byId).length,
      sectionsLength: sections.length,
      order,
    });
    return sections;
  },
);

export const selectVisibleSections: any = createSelector(
  [selectSectionsArray],
  (sections: any) => {
    const visible = sections.filter(
      (s: any) => s && s.section_identifier && !s.is_hidden,
    );
    console.log("🟡 Selector selectVisibleSections recomputed:", {
      totalSections: sections.length,
      visibleSections: visible.length,
      visibleIds: visible.map((s: any) => s.id),
    });
    return visible;
  },
);

export const selectSelectedSectionId: any = createSelector(
  [getWebbuilderState],
  (wb: any) => wb.selectedSectionId || null,
);

export const selectSelectedSection: any = createSelector(
  [selectSectionsById, selectSelectedSectionId],
  (byId: any, id: any) => (id ? byId[id] || null : null),
);

export const selectPreviewHiddenSectionIds: any = createSelector(
  [getWebbuilderState],
  (wb: any) => wb.previewHiddenSectionIds || [],
);

export const selectSectionById = (id: string) =>
  createSelector([selectSectionsById], (byId: any) => byId[id] || null);
